import { ref, unref, watch } from 'vue'

import { useFetch } from '@vueuse/core'

import { useDataStore } from '@/stores/data'
import { useStateStore } from '@/stores/state'

const useIO = () => {

  const dataStore = useDataStore()
  const stateStore = useStateStore()

  const useFetchVueUse = (url: any, fetchOptions: object, dataPost: any = undefined) => {
    if (dataPost !== undefined) {
      const {
        isFetching,
        error,
        data,
        execute,
        onFetchError
      } = useFetch(
        url,
        {
          immediate: false,
          ...fetchOptions
        }
      ).post(dataPost).json()

      return { isFetching, error, data, execute, onFetchError }
    } else {
      const {
        isFetching,
        error,
        data,
        execute,
        onFetchError
      } = useFetch(
        url,
        {
          immediate: false,
          ...fetchOptions
        }
      ).json()

      return { isFetching, error, data, execute, onFetchError }
    }
  }

  const updateGlobalLoading = (metaId: string, state: boolean) => {
    if (metaId === '') return

    stateStore.update(
      metaId,
      {
        global: {
          loading: state
        }
      }
    )
  }

  const performGetBucket = (
    url: any,
    fetchOptions: object,
    metaId: string,
    handler: (response: any) => void
  ) => {

    const isFetching = ref(false)

    const {
      isFetching: isFetchingFetch,
      error,
      data,
      execute,
      onFetchError
    } = useFetchVueUse(url, fetchOptions)

    onFetchError((error) => {
      console.error("onFetchError", error.message)
    })

    watch(
      isFetchingFetch,
      () => {
        isFetching.value = isFetchingFetch.value
        updateGlobalLoading(metaId, isFetchingFetch.value)
      }
    )

    watch(
      error,
      (n) => {
        console.error("error:", n)
      }
    )

    watch(
      data,
      (n) => {
        updateGlobalLoading(metaId, false)

        if (!n || n.data === null) return

        if ('data' in n) {
          for (const bucket in n.data) {
            dataStore.replace(bucket, n.data[bucket])
          }
        }
        if ('state' in n) {
          for (const bucket in n.state) {
            stateStore.update(bucket, n.data[bucket])
          }
        }
        if ('__messages' in n) {
          if (typeof $ !== "undefined") {
            $(document).trigger('hcl.hcl-notify', n['__messages']);
          }
        }
      }
    )

    execute()
      .then(
        () => handler(unref(data))
      ).catch(
        () => error
      )

    return { isFetching, error, data }
  }

  const performPostBucket = (
    url: any,
    fetchOptions: object,
    dataPost: any,
    metaId: string,
    handler: (response: any) => void
  ) => {
    const isFetching = ref(false)

    const {
      isFetching: isFetchingFetch,
      error,
      data,
      execute,
      onFetchError
    } = useFetchVueUse(url, fetchOptions, dataPost)

    onFetchError((error) => {
      console.error("onFetchError", error.message)
    })

    watch(
      isFetchingFetch,
      () => {
        isFetching.value = isFetchingFetch.value
        updateGlobalLoading(metaId, isFetchingFetch.value)
      }
    )

    watch(
      error,
      (n) => {
        console.error("error:", n)
      }
    )

    watch(
      data,
      (n) => {
        updateGlobalLoading(metaId, false)

        if (!n || n.data === null) return

        if ('data' in n) {
          for (const bucket in n.data) {
            dataStore.replace(bucket, n.data[bucket])
          }
        }
        if ('state' in n) {
          for (const bucket in n.state) {
            stateStore.updateFromBatch(n.state)
          }
        }
        if ('__messages' in n) {
          if (typeof $ !== "undefined") {
            $(document).trigger('hcl.hcl-notify', n['__messages']);
          }
        }
      }
    )

    execute()
      .then(
        () => handler(unref(data))
      ).catch(
        () => error
      )

    return { isFetching, error, data }
  }

  const performFetchJson = async (url, options) => {

    const mergedOptions = {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      ...options
    }

    try {
      const response = await fetch(url, mergedOptions);
      if (!response.ok) {
        console.error("There has been a problem with your fetch operation!");
        return undefined
      }

      const json = await response.json()

      if ('__messages' in json) {
        if (typeof $ !== "undefined") {
          $(document).trigger('hcl.hcl-notify', json['__messages']);
        }
      }

      return json
    } catch (error) {
      console.error("There has been a problem with your fetch operation:", error);
    }

    return undefined

  }

  return {
    performGetBucket,
    performPostBucket,
    performFetchJson
  }
}

export {
  useIO
}
